// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationTouchResponseData {
    static getAttributeTypeMap() {
        return AuthenticationTouchResponseData.attributeTypeMap;
    }
}
AuthenticationTouchResponseData.discriminator = undefined;
AuthenticationTouchResponseData.additionalProperties = false;
AuthenticationTouchResponseData.attributeTypeMap = [
    {
        "name": "token",
        "baseName": "token",
        "type": "string"
    },
    {
        "name": "sessionId",
        "baseName": "sessionId",
        "type": "number"
    },
    {
        "name": "createDate",
        "baseName": "createDate",
        "type": "Date"
    },
    {
        "name": "expirationDate",
        "baseName": "expirationDate",
        "type": "Date"
    },
];
//# sourceMappingURL=authenticationTouchResponseData.js.map